export default {
    profile: 'Profile',
    name: 'Name',
    employeeNo: 'Employee No',
    department: 'Department',
    group: 'Group',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Status',
    contact: 'Contact',
    email: 'Email Address',
    phoneNumber: 'Phone Number',
    checkInStatus: 'Check-In Status',
    date: 'Date',
    checkInLocation: 'Location',
    viewAttendance: 'View Attendance',
    attachmentFile: 'Attachment File',
    checkInDetail: 'Detail',
    time: 'Time'
}
